import React, {useContext, useEffect} from 'react'
import headbandContext from 'contexts/headband'
import "./formations.scss"
import { QRCodeSVG } from 'qrcode.react'
import BigButton from 'components/buttons/bigButton'
import Popup from 'reactjs-popup'
import { Document, Page } from 'react-pdf';
import PdfReader from 'components/pdfReader/pdfReader'
export default function Formation(props) {
    const {setCounter, counterDefault} = props
    const {setHeadband} = useContext(headbandContext)
    useEffect(() => {
        setHeadband({
            title :  "Les formations",
            icon : "picto actu formations - v2.svg",
            color : "bckDarkBlue"
        })
    }, [])
    return (
        <div className="w100 h100 flex column page" id="formations">
            <h2>Le plan de formation</h2>
                <Popup 
                    trigger={
                        <div className='w100 flex center'>
                            <div className='cadre'>
                                Visualiser le plan de formation
                            </div>
                            <img className='pictoPDF' src="/picto PDF a visualiser.svg" alt="" />
                        </div> 
                    }
                    modal
                    closeOnDocumentClick
                >
                    {
                        close => (
                            <PdfReader file="Plan_2022.pdf" close={close} setCounter={setCounter} counterDefault={counterDefault}/>
                        )
                    }
                </Popup>
            <div className='w100 flex center'>
                <div className='cadre'>
                    Le plan de formation à télécharger
                </div>
                <QRCodeSVG value="https://chu-rouen-drhf.spin-io.fr/pdf/Plan_2022.pdf" fgColor='#215fa5' bgColor='none' className='qrcode' size={150} />
            </div>
            <div className='w100 flex center'>
                <BigButton 
                    title={"L'actu de la semaine"}
                    icon={"picto_actu.svg"}
                    page={"/accueil/parcours_formations/formations/actus"} 
                    background={"bckDarkBlue"}                   
                    right="600px"
                    delay="0"
                />
                <BigButton 
                    title={"La liste des formations par dates"}
                    icon={"picto_formations_dates.svg"}
                    page={"/accueil/parcours_formation/formations/liste_formation"} 
                    background={"bckDarkBlue"} 
                    left="600px"
                    delay="0"
                />
            </div>
        </div>
    )
}
